@if (provider === 'haynespro') {
  <!-- <img src="assets/images/logo_HaynesPro.svg" alt="" width="17" height="17" class="inline-block !h-[18px] !w-[70px]" title="Haynes Pro" /> -->
  <p-tag severity="secondary" icon="pi pi-database" value="Haynes Pro" />
} @else if (provider === 'mercedes') {
  <!-- <img src="assets/images/logo_MercedesBenz_64x64.png" alt="" width="17" height="17" class="inline-block !h-[18px] !w-[18px]" title="Mercedes Benz" /> -->
  <p-tag severity="secondary" icon="pi pi-database" value="Mercedes Benz" />
} @else if (provider === 'volkswagen') {
  <!-- <img src="assets/images/logo_vw.png" alt="" width="17" height="17" class="inline-block !h-[18px] !w-[18px]" title="Volkswagen" /> -->
  <p-tag severity="secondary" icon="pi pi-database" value="Volkswagen" />
} @else if (provider === 'skoda') {
  <p-tag severity="secondary" icon="pi pi-database" value="Skoda" />
} @else if (provider === 'seat') {
  <p-tag severity="secondary" icon="pi pi-database" value="Seat" />
} @else if (provider === 'audi') {
  <p-tag severity="secondary" icon="pi pi-database" value="Audi" />
} @else if (provider === 'tesla') {
  <p-tag severity="secondary" icon="pi pi-database" value="Tesla" />
} @else if (provider === 'hgs') {
  <!-- <img
    src="assets/images/logo_HGS.png"
    alt=""
    width="20"
    height="20"
    class="inline-block !h-[18px] !w-[90px] rounded"
    title="Hella Gutmann Solutions GmbH" /> -->
  <p-tag severity="secondary" icon="pi pi-database" value="Hella Gutmann" />
} @else if (provider === 'varta') {
  <!-- <img src="assets/images/logo_VARTA.svg" alt="" height="17" class="inline-block !h-[17px] !w-[90px] rounded" title="Varta" /> -->
  <p-tag severity="secondary" icon="pi pi-database" value="Varta" />
} @else {
  <img src="assets/images/svgIcons/qira-icon.svg" alt="" width="17" height="17" class="inline-block !h-[18px] !w-[18px] rounded" title="Qira" />
}
